import axios from "axios";
import * as cheerio from "cheerio";
/* import stringSimilarity from "string-similarity";
import namer from "color-namer"; */

export async function fetchHtml(url: string): Promise<string> {
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching HTML:", error);
    throw error;
  }
}

export async function fetchAndParseDom(url: string): Promise<any> {
  const html = await fetchHtml(url);
  const $ = cheerio.load(html);
  return $;
}

export const getProductLogo = (productImages: string): string => {
  try {
    // Clean and fix the product_images string
    let cleanedImages = productImages.replace(/^"|"$/g, ""); // Remove wrapping quotes
    if (!cleanedImages.startsWith("[")) {
      cleanedImages = `[${cleanedImages}]`; // Ensure it is wrapped in square brackets
    }
    // Replace single quotes with double quotes to make it valid JSON
    cleanedImages = cleanedImages.replace(/'/g, '"');
    const parsedImages = JSON.parse(cleanedImages); // Parse as JSON
    return parsedImages?.[0] || ""; // Return the first image or fallback to an empty string
  } catch (error) {
    console.error("Error parsing product images:", error, productImages);
    return ""; // Fallback to an empty string in case of error
  }
};

function rgbToHex(r: number, g: number, b: number): string {
  return "#" + [r, g, b].map((x) => x.toString(16).padStart(2, "0")).join("");
}

// Utility: extract color from (x, y)
export const getColorFromCoordinates = (
  img: HTMLImageElement,
  coordinates: { x: number; y: number },
  blockSize: number,
  productColor: string
): string | null => {
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  if (!ctx) return null;

  canvas.width = img.naturalWidth;
  canvas.height = img.naturalHeight;
  ctx.drawImage(img, 0, 0);

  const { x, y } = coordinates;
  const data = ctx.getImageData(x, y, blockSize, blockSize).data;

  let r = 0,
    g = 0,
    b = 0,
    count = 0;
  for (let i = 0; i < data.length; i += 4) {
    r += data[i];
    g += data[i + 1];
    b += data[i + 2];
    count++;
  }

  r = Math.floor(r / count);
  g = Math.floor(g / count);
  b = Math.floor(b / count);
  console.log("picked color", `rgb(${r}, ${g}, ${b})`);
  // const matchedColor = getClosestColorMatchFromNamer(productColor, { r, g, b });
  // Example usage:
  const hex = rgbToHex(r, g, b);
  console.log(hex); // ➝ "#f87306"
  return `rgb(${r}, ${g}, ${b})`;
  // return matchedColor?.hex || hex;
};
